import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { usePageMeta } from "../hooks/usePageMeta";

export default function NotFoundPage() {
  usePageMeta("notFound");
  
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <main className="flex-grow flex items-center justify-center pt-20 md:pt-24">
        <div className="max-w-2xl mx-auto px-6 md:px-12 py-16 text-center">
          <h1 className="font-heading font-bold text-6xl sm:text-8xl uppercase mb-4">
            404
          </h1>
          <h2 className="font-heading font-bold text-2xl sm:text-3xl uppercase mb-6">
            Page Not Found
          </h2>
          <p className="font-body text-zinc-600 mb-8 max-w-md mx-auto">
            The page you're looking for doesn't exist or has been moved. Check the URL or navigate back to a known page.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/"
              className="bg-black text-white h-12 px-8 uppercase font-bold text-sm tracking-widest border-2 border-black btn-brutal flex items-center justify-center"
            >
              Go Home
            </Link>
            <Link
              to="/tender-red-review"
              className="bg-white text-black h-12 px-8 uppercase font-bold text-sm tracking-widest border-2 border-black hover:bg-zinc-100 transition-colors flex items-center justify-center"
            >
              Tender Red Review
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
